/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const StageExecutionStatusDto = {
    NotInitialized: 'NOT_INITIALIZED',
    NotAvailable: 'NOT_AVAILABLE',
    NotStarted: 'NOT_STARTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Expired: 'EXPIRED'
} as const;

export type StageExecutionStatusDto = typeof StageExecutionStatusDto[keyof typeof StageExecutionStatusDto];



